import { useContext, useState } from 'react'

import { useDeleteAiTagMutation } from '@/common/api/modules/aiTag'
import { useShowDeletedToast } from '@/common/app/toast'

import IconButton from '@/components/view/atoms/button/IconButton'
import DisclosureRow from '@/components/view/atoms/disclosure/DisclosureRow'
import { IconType } from '@/components/view/atoms/icon/Icon'
import Text from '@/components/view/atoms/text/Text'
import { DisclosurePositionVertical } from '@/components/view/layouts/disclosure/Disclosure'
import DisclosureWrapper from '@/components/view/layouts/disclosure/DisclosureWrapper'

import { ConfirmDialogContext } from '@/components/container/modal/dialog/confirm/ConfirmDialogProvider'

interface Props {
  siteId: number
  selectedIds: number[]
  reload: () => void
}

const AITagListBulkOperationButton = ({ siteId, selectedIds, reload }: Props) => {
  const [showing, setShowing] = useState<boolean>(false)

  const showDelete = useShowDeletedToast()
  const { trigger: deleteTag } = useDeleteAiTagMutation()
  const { showModal: showConfirm, hide: hideConfirm } = useContext(ConfirmDialogContext)

  return (
    <DisclosureWrapper
      off={!showing}
      vertical={DisclosurePositionVertical.TOP}
      disclosureNode={
        <>
          <DisclosureRow
            onClick={() => {
              showConfirm({
                message: `選択した${selectedIds.length}件のAIタグを削除しますか？`,
                noText: 'キャンセル',
                yesText: '削除する',
                onClickYes: async () => {
                  for (const id of selectedIds) {
                    await deleteTag({ site_id: siteId, tag_id: id })
                  }
                  hideConfirm()
                  showDelete(`選択した${selectedIds.length}件のAIタグ`)
                  reload()
                }
              })
            }}
          >
            <Text lineHeight={150}>AIタグを一括削除</Text>
          </DisclosureRow>
        </>
      }
      onClickOutSide={() => setShowing(false)}
    >
      <IconButton type={IconType.OTHER} color='emphasis' onClick={() => setShowing(true)} />
    </DisclosureWrapper>
  )
}

export default AITagListBulkOperationButton
